module.exports = __webpack_public_path__ + "img/innovations_small@2x.13cfbcb1.webp";